import React from 'react';
import { string, number, bool, arrayOf, shape } from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import TrailPropType from '../../../../../proptypes/TrailPropType';
import styles from './styles/styles.module.scss';
import FeedItemWrapper from '../FeedItemWrapper';
import FeedRiver from '../../FeedRiver';
import MiniTrailCard from '../../cards/MiniTrailCard';
import RiverImage from '../../FeedRiver/RiverImage';
import { setActiveModal } from '../../../ducks/modals';
import { LIGHTBOX } from '../../../constants';

const PhotosFeedItem = ({ photos, user, timestamp, description, trail }) => {
  const { context } = useSelector(state => state, shallowEqual);
  const dispatch = useDispatch();

  const handlePhotoClick = startingIndex => {
    const images = photos.map(p => {
      return { id: null, url: p.imgUrl };
    });

    dispatch(setActiveModal(LIGHTBOX, { startingIndex, images }));
  };

  return (
    <FeedItemWrapper user={user} timestamp={timestamp} description={description} context={context}>
      <div className={styles.container}>
        {photos.length === 1 ? (
          <div className={styles.singleImage}>
            <RiverImage photo={photos[0]} onClick={() => handlePhotoClick(0)} />
          </div>
        ) : (
          <FeedRiver>
            {photos.map((photo, idx) => {
              return <RiverImage photo={photo} idx={idx} key={photo.imgUrl} onClick={() => handlePhotoClick(idx)} />;
            })}
          </FeedRiver>
        )}
        {trail && <MiniTrailCard trail={trail} context={context} className={styles.miniTrailCardSpacer} />}
      </div>
    </FeedItemWrapper>
  );
};

PhotosFeedItem.propTypes = {
  description: string,
  timestamp: string.isRequired,
  photos: arrayOf(
    shape({
      id: number,
      imgUrl: string
    })
  ).isRequired,
  trail: TrailPropType,
  user: shape({
    firstName: string,
    id: number,
    lastName: string,
    links: arrayOf(
      shape({
        href: string,
        rel: string
      })
    ),
    pro: bool,
    profilePhoto: shape({
      href: string
    })
  }).isRequired
};

export default PhotosFeedItem;
